import { createTheme } from '@mui/material/styles';

export const COLORS = {
  // Primary brand blue (logo, links, primary actions)
  primary: '#1F72E7',
  primaryHover: '#195FC4',

  // Deeper blue used for the Upload / solid nav buttons
  primaryDark: '#27589F',
  primaryDarkHover: '#1648C0',
  primaryLight: '#A5C7F5',


  // Text
  text: '#374151',
  textMuted: '#6B7280',

  // Surfaces / backgrounds
  page: '#FDFCFB',
  white: '#FFFFFF',
  panelGradient: 'linear-gradient(135deg, #FBF9F6 0%, #F1ECE3 100%)',

  // Borders / dividers
  border: '#D8DEE7',
  hairline: '#E5E7EB',

  // Subtle interaction states
  tintedHover: '#F5F8FE',

  // Semantic states
  success: '#68B254',
  error: '#EF4444',
  warning: '#F59E0B',
  disabled: '#B1AFAD',

  // Light surface tints (info / error boxes)
  infoBg: '#F0F4FF',
  errorBg: '#FFE6E6',

  // ---- Explore My Talk: feedback category colors ----
  // Used for flower/leaf icons, turn borders, and the "solid fill" highlight
  // on the specific turn a piece of feedback is about.
  categoryContentKnowledge: '#97c3f3',
  categoryLearningCommunity: '#eed571',
  categoryRigorousThinking: '#f07d7f',
  categoryImprovementFallback: '#4caf50',
  categoryDefault: '#e0e0e0',

  // Acorn/leaf icon accent (the "Opportunity" icon body)
  acornBrown: '#795548',

  // ---- Explore My Talk: surfaces ----
  feedbackCardBorder: '#e0e0e0',
  feedbackCardBg: '#fafafa',
  explorePageBg: '#f5f5f5',
  studentRowBg: '#f5f5f5',
  studentRowHoverBg: '#eeeeee',
  transcriptHoverTint: '#a7c6e6ff',

  // ---- Explore My Talk: category chip tints ----
  // Each category gets a light background tint and a matching darker text color.
  chipLearningCommunityBg: 'rgba(238, 213, 113, 0.15)',
  chipContentKnowledgeBg: 'rgba(151, 195, 243, 0.15)',
  chipRigorousThinkingBg: 'rgba(240, 125, 127, 0.15)',
  chipDefaultBg: 'rgba(25, 118, 210, 0.08)',

  chipLearningCommunityText: '#9d8e2a',
  chipContentKnowledgeText: '#1976d2',
  chipRigorousThinkingText: '#d32f2f',
  chipDefaultText: '#1976d2',

  // Generic pure-black icon color (prev/next feedback nav arrows)
  iconDark: '#000',

  // Lighter acorn-cap accent used in the "Opportunity" icon illustration
  acornCap: '#c5a572',
};

export const FONT_FAMILY = "'Mulish', 'Noto Sans', 'Segoe UI', sans-serif";
export const FONT_HEADING = "'Lustria', Georgia, 'Times New Roman', serif";

export const BUTTON_HOVER = {
  gradient: 'linear-gradient(90deg, #4A97F4 0%, #1F72E7 100%)',
  shadow: '0 1px 10px rgba(0,0,0,0.12), 0 4px 5px rgba(0,0,0,0.14), 0 2px 4px -1px rgba(0,0,0,0.2)',
};

export const BUTTON_HOVER_SX = {
  backgroundColor: COLORS.primary,
  backgroundImage: BUTTON_HOVER.gradient,
  boxShadow: BUTTON_HOVER.shadow,
};

export const appTheme = createTheme({
  typography: {
    fontFamily: FONT_FAMILY,
    h4: { fontFamily: FONT_HEADING },
    h5: { fontFamily: FONT_HEADING },
    h6: { fontFamily: FONT_HEADING },
  },
  palette: { primary: { main: COLORS.primary } },
});
export default COLORS;